import MatchHeight from '../../models/match-height';

export default class{

    /**
     * constructor
     */
    constructor(){
        this.matchHeight = new MatchHeight('.s-product-gift-wrapping__body');
    }

    /**
     * init
     */
    init(){}

}